import * as React from 'react'
import { ReactElement, useCallback, useState } from 'react'
import { Card } from '@fluentui/react-components'
import { ViewCRMProps } from '../ViewCRM'
import DocumentFlatTree, { DocumentSelectionStrategy } from '../../../../components/Document/DocumentFlatTree'
import { DocumentSortOrder } from '../../../../config/documentConfig'

export default function CRMDocumentOverview(props: ViewCRMProps): ReactElement {
    const [selectedOptions, setSelectedOptions] = useState<string[]>([])

    const onOptionsSelect = useCallback((ids: string[]) => {
        setSelectedOptions(ids)
    }, [])

    return (
        <Card>
            <DocumentFlatTree
                rootId={props.crmRelation.documentRootId}
                selectionStrategy={DocumentSelectionStrategy.Single}
                sortOrder={DocumentSortOrder.NameAsc}
                selectedOptions={selectedOptions}
                onOptionsSelect={onOptionsSelect}
            />
        </Card>
    )
}
